import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/switch.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import PropsUtils from '../../packages/props-utils/props-utils.js';
import { InputInfoChildren, InputInfo } from '../_atoms/input-info/input-info.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('switch', styles);
var Switch = function (_a) {
  var disabled = _a.disabled,
    extraClasses = _a.extraClasses,
    id = _a.id,
    info = _a.info,
    infoError = _a.infoError,
    label = _a.label,
    stacked = _a.stacked,
    small = _a.small,
    ariaDescribedByProp = _a["aria-describedby"],
    rest = __rest(_a, ["disabled", "extraClasses", "id", "info", "infoError", "label", "stacked", "small", 'aria-describedby']);
  return /*#__PURE__*/React__default__default.createElement("label", {
    htmlFor: id,
    className: bem.b({
      disabled: disabled,
      stacked: stacked,
      error: infoError,
      sm: small
    }, extraClasses)
  }, /*#__PURE__*/React__default__default.createElement("input", __assign({
    id: id,
    className: bem.e('input'),
    type: "checkbox",
    disabled: disabled,
    "aria-errormessage": "infoError-".concat(id),
    "aria-describedby": PropsUtils.handleAriaDescribedBy(info ? "info-".concat(id) : undefined, ariaDescribedByProp)
  }, infoError && {
    'aria-invalid': true
  }, rest)), /*#__PURE__*/React__default__default.createElement("div", {
    className: bem.e('label')
  }, label), /*#__PURE__*/React__default__default.createElement(InputInfo, {
    error: true,
    id: id,
    className: bem.e('info')
  }, infoError), info && /*#__PURE__*/React__default__default.createElement(InputInfo, {
    id: id,
    className: bem.e('info')
  }, info));
};
Switch.displayName = 'Switch';
Switch.defaultProps = {
  disabled: undefined,
  extraClasses: '',
  info: undefined,
  infoError: undefined,
  stacked: false,
  small: false,
  label: undefined
};
Switch.propTypes = {
  disabled: PropTypes__default.bool,
  extraClasses: PropTypes__default.string,
  id: PropTypes__default.string.isRequired,
  info: InputInfoChildren,
  infoError: InputInfoChildren,
  label: function (_a) {
    var ariaLabel = _a["aria-label"],
      label = _a.label;
    // if no aria label nor label throw validation error
    return !ariaLabel && !label ? new Error('Either label or aria-label are required for Switch component.') : null;
  },
  stacked: PropTypes__default.bool,
  small: PropTypes__default.bool
};
var _switch = Injecss(Switch, styles);

export { Switch, _switch as default };
